import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import { ErrorBoundaryState, NotFound } from '@src/components/utils';

const component = () => <Outlet />;
const errorComponent = (props) => <ErrorBoundaryState {...props} />;
const notFoundComponent = () => <NotFound />;

const options = {
  component,
  notFoundComponent,
};

if (import.meta.env.MODE === 'production') {
  options.errorComponent = errorComponent;
}

export const Route = createRootRouteWithContext()(options);
